export const TABS = {
    QUOTATION: {
      tab: "0",
      value: "Generate Quotations",
    },
    HISTORY: {
      tab: "1",
      value: "Quotation History",
    },
  };